import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterLoaderGroups',
    standalone: false
})
export class FilterLoaderGroupsPipe implements PipeTransform {
	transform(loaderGroups: { isActive: boolean }[]): any[] {
		return loaderGroups?.length ? loaderGroups.filter(l => l.isActive) : loaderGroups;
	}
}
